import useWizardFormCtx from '../../../ctx-provider/useWizardFormCtx';
import StvAnrede from '../../../../../../consumer/form/dto/StvAnrede';
import RadioField from '../../../../../cmp/input/RadioField';
import RadioGroupField from '../../../../../cmp/input/RadioGroupField';
import FormBo from '../../FormBo';
import { useState } from 'react';
import GtmFormularfeldId from '../../../../../../gtm/types/GtmFormularfeldId';

export const exportVnAnrede = (bo: FormBo) => bo.vnAnrede;

export const importVnAnrede = (vnAnrede: StvAnrede) => vnAnrede;

const VnAnrede = () => {
    // *** Formulardaten werden geladen
    const { wizardFormBo, fireWizardFormBo } = useWizardFormCtx();
    const [vnAnrede, setVnAnrede] = useState(wizardFormBo.antrag.vnAnrede);

    // ****************************
    // Handle on blur
    // ****************************
    // Validierung
    const handleOnBlur = (event: React.FocusEvent<HTMLInputElement>) => {
        const value = event.target.value;
        wizardFormBo.antrag.vnAnrede = StvAnrede[value as StvAnrede];
        fireWizardFormBo(wizardFormBo);
    };

    // Formulardaten werden aktualisiert
    const handleOnChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        const value = event.target.value;
        setVnAnrede(StvAnrede[value as StvAnrede]);
    }

    return (
        <RadioGroupField id='vnAnrede' idGtm={GtmFormularfeldId.vnAnrede} name="vnAnrede" value={vnAnrede} onChange={handleOnChange} onBlur={handleOnBlur}>
            <RadioField value={StvAnrede.FRAU} label="Frau" />
            <RadioField value={StvAnrede.HERR} label="Herr" />
        </RadioGroupField>
    );
}

export default VnAnrede;